import React from "react";
import { findIcon } from "../../../../../dashboard/icons";

const LBLPrescriberDetails = () => {
  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex">
          <span className="me-2">
            <i className={`icon text-black`}>
              {findIcon("info", "outline", 14)}
            </i>
          </span>
          <p style={{ color: "#525252" }}>
            <span className="text-black fw-semibold">
              Leave Behind Literature (LBL)
            </span>{" "}
            is printed or digital material given to clients or prospects after a
            meeting to reinforce key points and support follow-up. Used in
            sales, marketina, and business development.
          </p>
        </div>
        <ul style={{ color: "#525252" }}>
          <li className="mb-0">
            <span className="poppins-medium">LBL Sent: </span>Materials
            dispatched or shared (physically or digitally).
          </li>
          <li>
            <span className="poppins-medium">LBL Delivered: </span>
            Materials successfully received (physically delivered or accessed
            digitally).
          </li>
        </ul>
      </div>
    </div>
  );
};

export default LBLPrescriberDetails;
